export const LIST_VIEW_ROUTES = ['software-list', 'classic-business-list', 'software-list-classic'];
